/**
 * @generated SignedSource<<3ec13a20554003dfc0bd718cc5b57a96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type reportedTimeTable_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly totalMinutesRegistered: number | null;
    readonly currency: string | null;
  } | null;
  readonly " $fragmentType": "reportedTimeTable_viewer";
};
export type reportedTimeTable_viewer$key = {
  readonly " $data"?: reportedTimeTable_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"reportedTimeTable_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "reportedTimeTable_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "searchQuery"
            }
          ],
          "kind": "ScalarField",
          "name": "totalMinutesRegistered",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "08f30e5bb4510e6dcfd81211db47d7b7";

export default node;
